import { PoolerUser } from '../../models/user';
import { SexEnum } from '../../models/sex.enum';

export function getEmploymentsCriteriaQuery(
  poolerUser: PoolerUser,
): Record<string, any> {
  const sexQuery = {
    $or: [
      {
        sex: SexEnum.ALL,
      },
      {
        sex: poolerUser.sex,
      },
      {
        sex: { $exists: false },
      },
    ],
  };
  const carQuery = {
    $or: [
      {
        car: { $exists: false },
      },
      {
        car: { $lte: poolerUser.car },
      },
    ],
  };
  const specialityQuery = {
    $or: [
      { specialities: { $exists: false } },
      { specialities: { $size: 0 } },
      {
        'specialities.id': {
          $in: (poolerUser.specialities ?? []).map(
            (speciality) => speciality.id,
          ),
        },
      },
    ],
  };
  const certificateQuery = {
    $or: [
      { certificates: { $exists: false } },
      { certificates: { $size: 0 } },
      {
        'certificates.id': {
          $in: (poolerUser.certificates ?? []).map(
            (certificate) => certificate.id,
          ),
        },
      },
    ],
  };
  const languageQuery = {
    $or: [
      { language: { $exists: false } },
      {
        language: { $in: poolerUser.languages ?? [] },
      },
    ],
  };
  return {
    $and: [
      sexQuery,
      carQuery,
      specialityQuery,
      certificateQuery,
      languageQuery,
    ],
  };
}
